import { styled, Typography, type TypographyProps } from "@mui/material";

export const FormContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexFlow: "column",
  gap: theme.spacing(3),
  [theme.breakpoints.up("tablet")]: {
    width: "480px",
  },
}));

export const MandatoryNote = (props: TypographyProps) => (
  <Typography sx={{ marginTop: "-8px" }} {...props}>
    * mandatory
  </Typography>
);
